import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";
import { cardHeaderStyles, cardContentStyles } from "../../../theme/mixins";

export const AvgResponseTimeWrapper = styled.div`
  margin-top: 20px;

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile};
  }
`;

export const AvgResponseTimeHeader = styled.div`
  ${cardHeaderStyles};
`;

export const AvgResponseTimeContent = styled.div`
  ${cardContentStyles};
`;
